import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { COMPRESSION_PILE, TENSION_PILE } from "../../../../constants";
import {
  selectLoadType,
  selectSafetyFactor,
  setCompression,
  setCompressionTest,
  setGroutFactor,
  setGroutFactorTest,
  setTension,
  setTensionTest,
} from "../../../../store/slices/fhwaSlice";
import { decimalSeparator, thousandSeparator } from "../../../../i18n";
import { NumericFormat as NumberFormat } from "react-number-format";
import { getClassName } from "../../../../components/Converter";
import ToolTip, { IconType } from "../../../../components/ToolTip";

function SafetyFactor() {
  const { t } = useTranslation("fhwa");
  const dispatch = useDispatch();
  const loadType = useSelector(selectLoadType);
  const safetyFactor = useSelector(selectSafetyFactor);
  const isCompression = loadType === COMPRESSION_PILE;
  return (
    <>
      {isCompression && (
        <>
          <RowBody
            titleValue={<p>{t("SafetyFactorGroutDesign")}</p>}
            indicesValue={<span>&alpha;</span>}
            inputValue={
              <NumberFormat
                value={safetyFactor?.GroutFactor}
                className={getClassName(safetyFactor?.GroutFactor)}
                decimalSeparator={decimalSeparator()}
                thousandSeparator={thousandSeparator()}
                decimalScale={2}
                displayType="input"
                type="text"
                onValueChange={(value) => dispatch(setGroutFactor(value.floatValue))}
              />
            }
            formulaValue={
              <ToolTip
                id={"SafetyFactorGroutDesign"}
                type={IconType.INFO}
                text={t("FHWA Micropile")}
              />
            }
          />
          <RowBody
            titleValue={<p>{t("SafetyGroutTest")}</p>}
            indicesValue={<span>&beta;</span>}
            inputValue={
              <NumberFormat
                value={safetyFactor?.GroutFactorTest}
                className={getClassName(safetyFactor?.GroutFactorTest)}
                decimalSeparator={decimalSeparator()}
                thousandSeparator={thousandSeparator()}
                decimalScale={2}
                displayType="input"
                type="text"
                onValueChange={(value) => dispatch(setGroutFactorTest(value.floatValue))}
              />
            }
          />
        </>
      )}
      <RowBody
        titleValue={<p>{t("SafetyFactorSteel")}</p>}
        indicesValue={<span>&gamma;</span>}
        inputValue={
          isCompression ? (
            <NumberFormat
              value={safetyFactor?.Compression}
              className={getClassName(safetyFactor?.Compression)}
              decimalSeparator={decimalSeparator()}
              thousandSeparator={thousandSeparator()}
              decimalScale={2}
              displayType="input"
              type="text"
              onValueChange={(value) => dispatch(setCompression(value.floatValue))}
            />
          ) : (
            <NumberFormat
              value={safetyFactor?.Tension}
              className={getClassName(safetyFactor?.Tension)}
              decimalSeparator={decimalSeparator()}
              thousandSeparator={thousandSeparator()}
              decimalScale={2}
              displayType="input"
              type="text"
              onValueChange={(value) => dispatch(setTension(value.floatValue))}
            />
          )
        }
        formulaValue={
          <ToolTip id={"SafetyFactorSteel"} type={IconType.INFO} text={t("FHWA Micropile")} />
        }
      />
      <RowBody
        titleValue={<p>{t("SafetyFactorSteelTest")}</p>}
        indicesValue={<span>&delta;</span>}
        inputValue={
          isCompression ? (
            <NumberFormat
              value={safetyFactor?.CompressionTest}
              className={getClassName(safetyFactor?.CompressionTest)}
              decimalSeparator={decimalSeparator()}
              thousandSeparator={thousandSeparator()}
              decimalScale={2}
              displayType="input"
              type="text"
              onValueChange={(value) => dispatch(setCompressionTest(value.floatValue))}
            />
          ) : (
            <NumberFormat
              value={safetyFactor?.TensionTest}
              className={getClassName(safetyFactor?.TensionTest)}
              decimalSeparator={decimalSeparator()}
              thousandSeparator={thousandSeparator()}
              decimalScale={2}
              displayType="input"
              type="text"
              onValueChange={(value) => dispatch(setTensionTest(value.floatValue))}
            />
          )
        }
      />
    </>
  );
}

export default SafetyFactor;
